import { render, staticRenderFns } from "./takeTaxiBox.vue?vue&type=template&id=efc7fd74&scoped=true"
import script from "./takeTaxiBox.vue?vue&type=script&lang=js"
export * from "./takeTaxiBox.vue?vue&type=script&lang=js"
import style0 from "./takeTaxiBox.vue?vue&type=style&index=0&id=efc7fd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc7fd74",
  null
  
)

export default component.exports